/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import TabComponent from "components/TabComponent";
import Button from "../../components/ButtonUse.jsx";
import axios from "axios";
import { baseURL } from "utils/api";
import useSWR from "swr";
import LoaderComponent from "components/Loader";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { categoryConfig } from "utils/awsCnfig";
import { uploadFile } from "react-s3";
import tempImage from "../../assets/images/clothes.jpg";
import ModalComponent from "components/MDTypography/ModalComponent";
window.Buffer = window.Buffer || require("buffer").Buffer;
// import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components

function EditCategory() {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setOpenDialog(false);
  const [category, setCategory] = useState(null);
  const [categoryImage, setCategoryImage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [showImgUpload, setShowImgUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [baseUrl, setbaseUrl] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreviewUrl(imageUrl);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        setbaseUrl(reader.result);
        console.log(reader, "===");
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    }
  };

  // upload category image to s3 bucket logic-:
  const uploadCategoryImageS3 = async () => {
    try {
      const { location } = await uploadFile(selectedFile, categoryConfig);

      return location;
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  console.log(categoryImage);
  //   fetch category names for select option-:

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  const { data, error } = useSWR(
    `${process.env.REACT_APP_BASE_URL}/fetch/categorynames`,
    fetchData
  );

  const [bodyData, setBodyData] = useState({
    name: "",
    gender: "",
    age: "",
    height: "",
    chest: "",
    weight: "",
    shoulder: "",
    waist: "",
    hip: "",
    foot: "",
  });
  const [isBodyData, setIsBodyData] = useState("");
  const options = data;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formState, setFormState] = useState({
    categoryName: "",
    parent: "",
    child: "",
    innerChild: "",
    innerinnerChild: "",
    subParent: "",
    innerParent: "",
    sortOrder: "",
    description: "",
    minimalSize: "",
    minimalWeight: "",
    deliveryByTrain: "",
    deliveryByAir: "",
    calculateShippingPriceByWeight: "",
    percentageOfProfit: "",
    metaTitle: "",
    metaTag: "",
    metaDescription: "",
    seoKeyword: "",
    pinned: false,
    subCategories: null,
    status: "",
  });

  console.log(previewUrl);
  // useEffect(() => {
  //     async function fetchCategory() {
  //         try {
  //             setLoading(true);
  //             const { data } = await axios.get(`${baseURL}/admin/category/${location.state}`);
  //             setLoading(false);
  //             setCategory(data?.category);
  //             setFormState({
  //                 ...formState,
  //                 categoryName: data?.category?.categoryName,
  //                 description: data?.category?.description,
  //                 parent: data?.category?.parent,
  //                 subParent: data?.category?.subParent,
  //                 innerParent: data?.category?.innerParent,
  //                 sortOrder: data?.category?.sortOrder,
  //                 minimalWeight: data?.category?.minimalWeight,
  //                 minimalSize: data?.category?.minimalSize,
  //                 deliveryByTrain: data?.category?.deliveryByTrain,
  //                 deliveryByAir: data?.category?.deliveryByAir,
  //                 percentageOfProfit: data?.category?.percentageOfProfit,
  //                 calculateShippingPriceByWeight: data?.category?.calculateShippingPriceByWeight,
  //                 metaTitle: data?.category?.metaTitle,
  //                 metaTag: data?.category?.metaTag,
  //                 metaDescription: data?.category?.metaDescription,
  //                 pinned: data?.category?.pinned,
  //             });
  //         } catch (error) {
  //             setLoading(false);
  //         }
  //     }
  //     fetchCategory();
  // }, []);

  const handleUploadCategory = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    const url = await uploadCategoryImageS3();
    const formData = new FormData();
    console.log(categoryImage);
    formData.append("categoryName", formState.categoryName);
    formData.append("parent", formState.parent);
    formData.append("child", formState.child);
    formData.append("innerChild", formState.innerChild);
    formData.append("innerinnerChild", formState.innerinnerChild);
    formData.append("description", formState.description);
    formData.append("sortOrder", formState.sortOrder);
    formData.append("pinned", formState.pinned);
    formData.append("staus", formState.status);
    formData.append("metaTags", formState.metaTag);
    formData.append("metaTitle", formState.metaTitle);
    formData.append("metaDescription", formState.metaDescription);
    formData.append("subcategories", formState.subCategories);
    formData.append("minimalSize", formState.minimalSize);
    formData.append("minimalWeight", formState.minimalWeight);
    formData.append("deliveryByTrain", formState.deliveryByTrain);
    formData.append("deliveryByAir", formState.deliveryByAir);
    formData.append("categoryImage", url);
    // formData.append("imgUrl", baseUrl);

    try {
      console.log(baseUrl);

      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload-category`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status === 200) {
        setFormLoading(false);
        // navigate("/categories");
      }
    } catch (error) {
      console.log(error);
      alert("Error uploading category");
      setFormLoading(false);
    }
  };
  console.log(typeof isBodyData);
  const tabProps = [
    {
      title: "General",
      content: (
        <GeneralDetailsForm
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          options={options}
          data={formState}
          setFunc={setFormState}
          isBodyData={isBodyData}
          setIsBodyData={setIsBodyData}
        />
      ),
      id: 1,
    },
    {
      title: "Data",
      content: (
        <DataForm
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          data={formState}
          setFunc={setFormState}
          preview={previewUrl}
          selectedFile={selectedFile}
          handleChange={handleFileChange}
          handleClose={handleClose}
          showImgUpload={showImgUpload}
          setShowImgUpload={setShowImgUpload}
        />
      ),
      id: 2,
    },
    {
      title: "SEO",
      content: <SeoForm data={formState} setFunc={setFormState} />,
      id: 2,
    },
    {
      title: isBodyData == 1 ? "Body Data" : "",
      content:
        isBodyData == "1" ? (
          <BodyDataForm
            isBodyData={isBodyData}
            setInputValues={setIsBodyData}
            bodyData={bodyData}
            setBodyData={setBodyData}
          />
        ) : (
          ""
        ),
      id: 4,
    },
  ];

  return (
    <DashboardLayout>
      {loading && <LoaderComponent open={true} />}
      {formLoading && <LoaderComponent open={true} />}
      <DashboardNavbar />
      <form
        onSubmit={handleUploadCategory}
        style={{
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        }}
      >
        <div style={{ display: "flex", gap: "20px", justifyContent: "end" }}>
          <Button title={"Submit"} background={"green"} type={"submit"} />
          <Button
            cliclHandler={() => {
              navigate(-1);
            }}
            title={"Cancel"}
            background={"red"}
            type={"button"}
          />
        </div>
        <TabComponent tabContent={tabProps} />
      </form>

      <Footer />
    </DashboardLayout>
  );
}

export default EditCategory;

function GeneralDetailsForm({
  options,
  selectedCategory,
  setSelectedCategory,
  data,
  setFunc,
  isBodyData,
  setIsBodyData,
}) {
  // console.log(selectedCategory);

  const GenerateCategoryInputs = ({ inputValue }) => {
    // Split the input value into an array
    const value_split = inputValue ? inputValue.value.split("/") : [];
    const [inputValues, setInputValues] = useState(value_split);
    // Use useEffect to update state when inputValue changes
    useEffect(() => {
      setInputValues(value_split);
    }, [inputValue]);

    // Define labels based on the index
    const labels = ["Parent", "Child", "Inner Child", "Inner Inner Child"];

    // Handle input value change
    const handleInputChange = (index, newValue) => {
      const newValues = [...inputValues];
      console.log(newValues);
      newValues[index] = newValue;
      setInputValues(newValues);
    };
    useEffect(() => {
      setFunc({ ...data, subCategories: inputValues });
      setFunc({
        ...data,
        categoryName: selectedCategory.value,
        parent: value_split[0],
        child: value_split[1],
        innerChild: value_split[2],
        innerinnerChild: value_split[3],
      });
    }, [inputValues, value_split]);

    // Map over the array and create input elements with labels
    const InputElements = () => {
      return (
        <>
          {value_split.map((value, index) => {
            return (
              <div className="flex flex-col gap-4" key={index}>
                <label>{labels[index]}</label>
                <input
                  className="w-[60vw] h-[6vh] pl-4"
                  value={value}
                  type="text"
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
              </div>
            );
          })}
        </>
      );
    };
    // useEffect(() => [
    //     setFunc({ ...data, parent: '' })
    // ])

    return (
      <>
        <InputElements />
      </>
    );
  };

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column", marginTop: "3vh" }}>
          <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Category Name*</span>
          <Select
            options={options}
            defaultValue={selectedCategory}
            onChange={setSelectedCategory}
          />
          {selectedCategory && <GenerateCategoryInputs inputValue={selectedCategory} />}

          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Description*</span>
            <textarea
              placeholder="write description"
              style={{ width: "60vw", padding: "10px" }}
              name=""
              id=""
              value={data?.description}
              onChange={(e) => setFunc({ ...data, description: e.target.value })}
              cols="30"
              rows="10"
            ></textarea>
          </div>
          <div className="flex gap-2 flex-col">
            <span className="text-sm font-semibold">isBodyData?</span>
            <select
              value={isBodyData}
              onChange={(e) => setIsBodyData(e.target.value)}
              className="h-[4vh] w-[12vw]"
            >
              <option value="">Select</option>
              <option>1</option>
              <option>0</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

function DataForm({
  data,
  setFunc,
  preview,
  selectedFile,
  handleChange,
  showImgUpload,
  setShowImgUpload,
}) {
  const handleShowImage = () => {
    setShowImgUpload(true);
  };

  const handleRemoveimg = () => {
    setShowImgUpload(false);
  };
  const statusOptions = [
    {
      value: "Enabled",
      label: "Enabled",
    },
    {
      value: "Disabled",
      label: "Disabled",
    },
  ];
  const [statuVal, setStatusVal] = useState(null);
  useEffect(() => {
    if (statuVal) {
      setFunc({ ...data, status: statuVal.value });
    }
  }, [statuVal]);

  return (
    <>
      <div style={{ padding: "5px", paddingBottom: "10vh" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          {!showImgUpload && (
            <div>
              <Button
                cliclHandler={handleShowImage}
                type={"button"}
                background={"green"}
                title={"Add Image"}
              />
            </div>
          )}

          {showImgUpload && (
            <div className="flex flex-col  w-[20vw] items-start justify-start">
              <span>Category Image</span>
              <label className="" htmlFor="profile_pic">
                <img
                  className="ml-[-3vw]"
                  style={{ width: "20vw", height: "20vh", objectFit: "contain", cursor: "pointer" }}
                  src={preview ? preview : tempImage}
                  alt="temp_img"
                />
              </label>
              <input
                id="profile_pic"
                style={{ display: "none" }}
                type="file"
                accept="image/*"
                onChange={handleChange}
              />
              <div className="flex">
                <Button type={"button"} title={"Remove Image"} cliclHandler={handleRemoveimg} />
              </div>
            </div>
          )}

          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Pinned*</span>
            <input
              checked={data?.pinned}
              onChange={(e) => setFunc({ ...data, pinned: !data.pinned })}
              style={{ cursor: "pointer" }}
              type="checkbox"
            />
          </div>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Minimal Weight"
            variant="outlined"
            value={data?.minimalWeight}
            onChange={(e) => setFunc({ ...data, minimalWeight: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Minimal Size"
            variant="outlined"
            value={data?.minimalSize}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, minimalSize: e.target.value });
              }
            }}
          />
          <div className="flex flex-col gap-3">
            <span className="text-sm font-semibold">Delivery By Train</span>
            <select
              value={data?.deliveryByTrain}
              onChange={(e) => setFunc({ ...data, deliveryByTrain: e.target.value })}
              className="w-[12vw] h-[6vh]"
            >
              <option value="">Select</option>
              <option>1</option>
              <option>0</option>
            </select>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-sm font-semibold">Delivery By Air</span>
            <select
              value={data?.deliveryByAir}
              onChange={(e) => setFunc({ ...data, deliveryByAir: e.target.value })}
              className="w-[12vw] h-[6vh]"
            >
              <option value="">Select</option>
              <option>1</option>
              <option>0</option>
            </select>
          </div>
          {/* <TextField
                        id="outlined-basic"
                        sx={{ width: "60vw" }}
                        label="Delivery By Train(Enter 1 for yes and 0 for No)"
                        variant="outlined"
                        value={data?.deliveryByTrain}
                        onChange={(e) => setFunc({ ...data, deliveryByTrain: e.target.value })}
                    /> */}
          {/* <TextField
                        id="outlined-basic"
                        sx={{ width: "60vw" }}
                        label="Delivery By Air "
                        variant="outlined"
                        value={data?.minimalWeight}
                        onChange={(e) => setFunc({ ...data, minimalWeight: e.target.value })}
                    /> */}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Percentage of Profit"
            variant="outlined"
            value={data?.percentageOfProfit}
            onChange={(e) => setFunc({ ...data, percentageOfProfit: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sort Order"
            variant="outlined"
            value={data?.sortOrder}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, sortOrder: e.target.value });
              }
            }}
          />
          <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Status*</span>
            <Select options={statusOptions} onChange={setStatusVal} />
          </div>
        </div>
      </div>
    </>
  );
}

function SeoForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Tag"
            // placeholder="Exmples"
            value={data?.metaTag}
            onChange={(e) => setFunc({ ...data, metaTag: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Title"
            // placeholder="Exmples"
            value={data?.metaTitle}
            onChange={(e) => setFunc({ ...data, metaTitle: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Description"
            // placeholder="Exmples"
            value={data?.metaDescription}
            onChange={(e) => setFunc({ ...data, metaDescription: e.target.value })}
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}

function BodyDataForm({ bodyData, setBodyData }) {
  return (
    <>
      <div className="p-4">
        <div className="flex flex-col gap-6">
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Gender</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Height</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Weight</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Shoulder</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Waist</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Chest</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Age</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Hip</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Foot</span>
              <select className="h-[4vh] w-[12vw]">
                <option value="">Select</option>
                <option>1</option>
                <option>0</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
